import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Spin } from "antd";
import { useGetUserData } from "../../../hooks/useGetUserData";
import { useCenterQuery } from "../../../hooks/useCenterQuery";

const ReviewQrGeneration = () => {
  const { data: userData } = useGetUserData();
  const { data: centerData } = useCenterQuery(userData?.slug);

  // Derived value (no need for useEffect + state)
  const centerDomain = centerData?.id
    ? centerData.slug === "jood"
      ? `https://jood.clinic/review/${centerData.id}`
      : `https://center.dreasey.com/review/${centerData.id}`
    : null;

  return (
    <div className="min-h-screen w-full mx-auto bg-gray-50 flex flex-col overflow-x-hidden">
      <div className="flex-1 flex flex-col items-center justify-start px-4 py-6 sm:py-10">
        <h2 className="text-lg sm:text-xl font-medium text-gray-900 mb-2 text-center">
          Rate our clinic
        </h2>
        <p className="text-sm text-gray-500 text-center leading-relaxed mb-6 max-w-xs sm:max-w-sm">
          Share this QR code with patients so they can easily leave a review.
        </p>

        <div className="bg-white border border-gray-100 rounded-2xl p-3 sm:p-5 mb-6 flex flex-col items-center gap-4 w-full max-w-[320px] sm:max-w-sm shadow-sm">
          <div className="relative p-1 w-full aspect-square flex items-center justify-center">
            {centerDomain ? (
              <QRCodeCanvas
                id="qr-canvas"
                value={centerDomain}
                size={400} // high-res canvas (good for download/print)
                bgColor="#ffffff"
                fgColor="#1a1a1a"
                level="H"
                // scale down visually to fit the card on any screen
                style={{ width: "100%", height: "auto" }}
              />
            ) : (
              <Spin />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewQrGeneration;